import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron up.svg` */
export const ChevronUpIcon = createTripletGlyphIcon('ChevronUpIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5528 10.7004C13.7966 11 13.7516 11.4406 13.4522 11.6848C13.1525 11.9287 12.7109 11.8838 12.4668 11.5842L7.86429 5.93476L3.60452 11.5646C3.37119 11.8726 2.93223 11.9336 2.62405 11.7004C2.31609 11.4671 2.25535 11.0281 2.48831 10.7199L7.21585 4.47187C7.52504 4.06322 8.13525 4.05224 8.45901 4.44941L13.5528 10.7004Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1472 12.0929C15.3909 12.3926 15.346 12.8332 15.0466 13.0773C14.747 13.3213 14.3054 13.2762 14.0613 12.9767L8.81322 6.53435L3.95384 12.9572C3.72058 13.2652 3.28157 13.3259 2.97337 13.0929C2.66516 12.8598 2.60461 12.4208 2.83763 12.1125L8.15599 5.08318C8.46965 4.66866 9.08837 4.65773 9.41673 5.06072L15.1472 12.0929Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.213 16.144C20.5269 16.5292 20.4691 17.0966 20.0841 17.4106C19.6989 17.7244 19.1325 17.6667 18.8185 17.2817L15.3058 12.9702L11.7931 8.65864L5.28819 17.2563C4.98825 17.6524 4.42372 17.7308 4.02745 17.4311C3.63123 17.1313 3.55316 16.5667 3.85265 16.1704L10.9444 6.79732C11.3497 6.26234 12.1493 6.24775 12.5733 6.76802L20.213 16.144Z"
        fill="currentColor"
      />
    </svg>
  ),
});
